import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=604a1511&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=604a1511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a1511",
  null
  
)

export default component.exports